import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
export var MatchConfidence = /*#__PURE__*/ function(MatchConfidence) {
    MatchConfidence["High"] = "high";
    MatchConfidence["Medium"] = "medium";
    MatchConfidence["Low"] = "low";
    return MatchConfidence;
}({});
export class AgreementImportExtractionModel {
    static fromDTO(dto) {
        return new AgreementImportExtractionModel(dto);
    }
    toDTO() {
        return this.dto;
    }
    clone() {
        return AgreementImportExtractionModel.fromDTO(_object_spread({}, this.dto));
    }
    agreementName() {
        var _this_dto_agreementName;
        return (_this_dto_agreementName = this.dto.agreementName) !== null && _this_dto_agreementName !== void 0 ? _this_dto_agreementName : '';
    }
    effectiveDate() {
        var _d_day;
        const d = this.dto.effectiveDate;
        if (d == null) return null;
        return new Date(d.year, d.month - 1, (_d_day = d.day) !== null && _d_day !== void 0 ? _d_day : 1);
    }
    paymentTermsDisplay(t) {
        const n = this.dto.netTerms;
        if (n == null) return null;
        if (n === 0) return t.agreementImport.triageModal.paymentTermsDueOnReceipt();
        return t.agreementImport.triageModal.paymentTermsDueIn({
            days: String(n)
        });
    }
    hasClientSignature() {
        return this.dto.hasClientSignature;
    }
    netTerms() {
        return this.dto.netTerms;
    }
    client() {
        return this.dto.client;
    }
    services() {
        return this.dto.services;
    }
    legalTerms() {
        return this.dto.legalTerms;
    }
    setAgreementName(name) {
        return AgreementImportExtractionModel.fromDTO(_object_spread_props(_object_spread({}, this.dto), {
            agreementName: name || undefined
        }));
    }
    setEffectiveDate(date) {
        const effectiveDate = date == null ? undefined : {
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate()
        };
        return AgreementImportExtractionModel.fromDTO(_object_spread_props(_object_spread({}, this.dto), {
            effectiveDate
        }));
    }
    constructor(dto){
        _define_property(this, "dto", void 0);
        this.dto = dto;
    }
}
